import { mapState } from 'vuex'

/**
 * Mixin that provides product inventory checking functionality for Kompack users
 *
 * @mixin isHavePacket
 * @description Provides methods to check if a user has products in their inventory
 * and display warning popups when no products are found.
 *
 */
// eslint-disable-next-line import/prefer-default-export
export const isHavePacket = {
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  methods: {
  /**
     * Checks if the user has any products in their inventory.
     * If products exist, shows a warning popup to input products first.
     * This method is called during component mounting to ensure users
     * have products before proceeding with packing requests.
     */
    checkIsHavePacket() {
      if (this.profile.is_kompack !== 1) return
      const params = {
        status: 1,
        limits: 1,
        offset: 0,
      }
      this.$http_komship.get('/v4/product', { params })
        .then(response => {
          const { data } = response.data
          if (data.length <= 0) {
            this.warnThatDoesntHavePacket()
          }
        })
    },
    /**
       * Popup warning that doesn't have packet
       * If the user confirms, do nothing
       * If the user cancels, do nothing
       */
    warnThatDoesntHavePacket() {
      this.$swal({
        title: 'Yuk Input Produk Terlebih Dahulu',
        icon: 'warning',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Input Produk',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: '!max-w-[620px] !w-full text-[#626262]',
          title: 'mb-1',
          icon: 'border-0 mb-[16px] !size-[92px]',
          actions: 'flex flex-row flex-wrap gap-2',
          confirmButton: 'btn btn-primary grow',
          cancelButton: 'btn btn-outline-primary grow',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$router.push({
            path: '/add-produk',
          })
        }
      })
    },
  },
}
